import React from "react";
import styled from "styled-components";

interface PropsType {
  children: React.ReactNode; // Define the children prop
}
const InputStyledComp: React.FC<PropsType> = (props) => {
  return <Root>{props.children}</Root>;
};
export default InputStyledComp;
const Root = styled.div`
  position: relative;
  background: linear-gradient(135deg, #ffffff 0%, #f9fafb 100%);
  padding: clamp(1.5rem, 4vw, 3.5rem) clamp(1.5rem, 4vw, 3rem);
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: 'Gilroy-Regular', 'Gilroy', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
    border-color: #d1d5db;
  }

  /* Small phones */
  @media (max-width: 480px) {
    padding: 1rem 0.75rem;
  }

  @media (max-width: 768px) {
    padding: 1.5rem 1rem;
  }
  
  /* Landscape phones */
  @media (max-width: 768px) and (orientation: landscape) {
    padding: 1rem;
  }

  .field_name,
  .title {
    font-family: 'Gilroy-Bold', 'Gilroy', sans-serif;
    font-size: clamp(1.75rem, 4vw, 2.25rem);
    font-weight: 700;
    color: #111827;
    margin-bottom: 1rem;
    line-height: 1.2;
    letter-spacing: -0.025em;
    background: linear-gradient(135deg, #111827 0%, #374151 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .sr_number {
    position: relative;
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    margin-bottom: 2rem;

    span {
      background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
      color: white;
      padding: 0.5rem 0.75rem;
      border-radius: 8px;
      font-size: 1rem;
      font-weight: 600;
      min-width: 2rem;
      text-align: center;
      box-shadow: 0 2px 4px -1px rgba(59, 130, 246, 0.5);
      flex-shrink: 0;
      margin-top: 0.25rem;

      @media (max-width: 768px) {
        font-size: 0.875rem;
        padding: 0.375rem 0.625rem;
        margin-top: 0.125rem;
      }
    }

    .text_danger {
      color: #ef4444;
      font-size: 1.25rem;
      font-weight: 600;
      margin-left: 0.5rem;
    }

    input {
      color: #111827 !important;
      background: #ffffff !important;
      -webkit-text-fill-color: #111827 !important;
    }
  }

  .discription {
    font-size: 0.9375rem;
    color: #94a3b8;
    line-height: 1.6;
    margin-bottom: 1.5rem;
    background: transparent;
    border: none;
    font-weight: 400;

    @media (max-width: 768px) {
      font-size: 0.875rem;
      margin-bottom: 1.25rem;
    }
  }

  input,
  textarea {
    width: 100%;
    padding: clamp(0.875rem, 2.5vw, 1.125rem) clamp(1.125rem, 3vw, 1.375rem);
    border: 2px solid #e5e7eb;
    border-radius: clamp(10px, 2vw, 14px);
    font-size: clamp(1rem, 3vw, 1.125rem);
    color: #111827 !important;
    background: #ffffff !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    font-family: 'Gilroy-Medium', 'Gilroy', inherit;
    min-height: 52px;
    font-weight: 500;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    -webkit-text-fill-color: #111827 !important;

    &:hover {
      border-color: #d1d5db;
      background: #ffffff;
    }

    &:focus {
      outline: none;
      border-color: #3b82f6;
      background: #ffffff;
      box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1), 0 2px 6px rgba(0, 0, 0, 0.08);
      transform: translateY(-1px);
    }

    &::placeholder {
      color: #cbd5e1;
      font-weight: 400;
      font-size: 0.9375rem;
      opacity: 0.7;

      @media (max-width: 768px) {
        font-size: 0.875rem;
      }
    }

    /* Small phones */
    @media (max-width: 480px) {
      font-size: 1rem;
      padding: 0.75rem 1rem;
      border-radius: 8px;
      min-height: 48px;
    }

    @media (max-width: 768px) {
      font-size: 1rem;
      padding: 0.875rem 1rem;
    }
    
    /* Landscape phones */
    @media (max-width: 768px) and (orientation: landscape) {
      padding: 0.625rem 1rem;
      min-height: 40px;
    }
  }

  .input_box {
    margin-top: 0;
  }

  textarea {
    min-height: 120px;
    resize: vertical;
    line-height: 1.6;
  }

  .react-tel-input {
    margin-top: 0;

    .flag-dropdown {
      border: 2px solid #e2e8f0;
      border-right: none;
      border-radius: 12px 0 0 12px;
      background: white;
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    }

    input.phone_input_left {
      border: 2px solid #e2e8f0;
      border-left: none;
      border-radius: 0 12px 12px 0;
      padding: 1rem 1.25rem;
      font-size: 1.125rem;
      color: #1e293b;
      background: white;
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

      &:focus {
        outline: none;
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
      }

      @media (max-width: 768px) {
        font-size: 1rem;
        padding: 0.875rem 1rem;
      }
    }

    &:focus-within .flag-dropdown {
      border-color: #3b82f6;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }
  }

  .dragggable_file {
    position: relative;
    margin-top: 0;

    input[type="file"] {
      width: 100%;
      height: 200px;
      opacity: 0;
      cursor: pointer;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
    }

    span {
      background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
      border: 2px dashed #cbd5e1;
      border-radius: 16px;
      height: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: 1rem;
      cursor: pointer;
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
      font-size: 1.125rem;
      color: #64748b;
      font-weight: 500;

      &:hover {
        background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
        border-color: #3b82f6;
        color: #3b82f6;
      }

      svg {
        width: 2rem;
        height: 2rem;
      }

      @media (max-width: 768px) {
        height: 160px;
        font-size: 1rem;
        gap: 0.75rem;
        
        svg {
          width: 1.5rem;
          height: 1.5rem;
        }
      }
    }
  }

  .all_files {
    display: flex;
    gap: 0.75rem;
    flex-wrap: wrap;
    margin-bottom: 1.5rem;

    span {
      background: #f8fafc;
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      padding: 0.5rem 0.75rem;
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-size: 0.875rem;
      color: #475569;
      max-width: 200px;
      
      /* Truncate long filenames */
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    button {
      background: none;
      border: none;
      padding: 0.25rem;
      cursor: pointer;
      color: #ef4444;
      border-radius: 4px;
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
      flex-shrink: 0;

      &:hover {
        background: #fef2f2;
      }

      img {
        width: 1rem;
        height: 1rem;
      }
    }
  }

  .end_screen_box {
    text-align: center;
    font-size: clamp(1.875rem, 5vw, 3rem);
    font-weight: 700;
    color: #1e293b;
    line-height: 1.2;
    letter-spacing: -0.025em;
    padding: 2rem;
  }

  .custome_date_box {
    position: relative;

    .date_input_box {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      z-index: 1;
    }

    .input_box {
      position: relative;
      z-index: 0;
      cursor: pointer;
    }
  }
`;
